import Markdown from "markdown-to-jsx";
import DOMPurify from "isomorphic-dompurify";

import Accordion from "@/components/ui/Accordion/Accordion";
import AccordionItem from "@/components/ui/Accordion/AccordionItem";

import styles from "./ItinerarySection.module.scss";

const ItinerarySection = ({ experience }) => {
  const accordionItems = experience.itinerary.dates.map((item, index) => {
    return (
      <AccordionItem
        title={item.time_span}
        icon="/assets/img/icons/calendar.svg"
        key={index}
        startOpen={false}
        titleFontSize="var(--font-size-md-sm)"
      >
        <Markdown>{DOMPurify.sanitize(item.description)}</Markdown>
      </AccordionItem>
    );
  });

  const { itinerary } = experience;
  const { schedule } = itinerary;
  return (
    <div className={`${styles.itineraryContainer} text-container`}>
      <div className={`${styles.schedule} `}>
        <Markdown>{DOMPurify.sanitize(schedule)}</Markdown>
      </div>
      <div>
        <Accordion>{accordionItems}</Accordion>
      </div>
    </div>
  );
};

export default ItinerarySection;
